import { Grid, IconButton, makeStyles, Typography } from "@material-ui/core";
import { ContactSupport, Instagram, LinkedIn, Twitter, Web } from "@material-ui/icons";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import * as ROUTES from "../../constants/routes";
import Logo from "../../assets/logo.png";

function Footer() {
  const styles = useStyles();
  const { t } = useTranslation();
  const history = useHistory();

  const handleLink = (url) => {
    window.open(url, "_blank").focus();
  };
  return (
    <Grid item x={12} container style={{ backgroundColor: "white" }}>
      <Grid item xs={12} className={styles.footerContainer}>
        <Typography className={styles.mainSubtitle} style={{ marginBottom: 0 }}>
          {t("productOf")}{" "}
          <img
            style={{ width: 150, marginLeft: 6, marginBottom: -2, cursor: "pointer" }}
            src={Logo}
            onClick={() => window.open("https://www.bexencardio.com/es/", "_blank").focus()}
          />
        </Typography>
      </Grid>

      <Grid item xs={12} container justify="flex-end" className={styles.footerContainer} alignItems="center">
        <Typography className={styles.mainSubtitle}>{t("contact")} </Typography>

        <IconButton onClick={() => history.push(ROUTES.SENDREPORT)}>
          <ContactSupport />
        </IconButton>
        <IconButton onClick={() => handleLink("https://www.bexencardio.com/es/")}>
          <Web />
        </IconButton>
        <IconButton onClick={() => handleLink("https://www.linkedin.com/company/bexen-cardio/")}>
          <LinkedIn />
        </IconButton>
        <IconButton onClick={() => handleLink("https://www.instagram.com/bexencardio/")}>
          <Instagram />
        </IconButton>
        <IconButton onClick={() => handleLink("https://twitter.com/BexenCardio")}>
          <Twitter />
        </IconButton>
      </Grid>
    </Grid>
  );
}

export default Footer;

const useStyles = makeStyles((theme) => ({
  mainSubtitle: {
    animation: "fade-down .8s ease .3s 1 normal both running",
    color: "#9aa0a6",
    font: "400 16px/26px Google Sans,Arial,sans-serif",
    marginRight: 9,
    [theme.breakpoints.up("md")]: {
      maxWidth: "80%",
    },
  },
  footerContainer: {
    borderBottom: "solid 1px rgba(0,0,0,.12)",
    [theme.breakpoints.up("md")]: {
      padding: "36px 108px",
    },
    [theme.breakpoints.down("md")]: {
      padding: "24px 16px",
      justifyContent: "flex-start",
    },
  },
}));
